import Container from 'components/Container';
import cx from 'classnames';
import Glyph, { GlyphColor } from 'components/Glyph';
import { GlyphName } from '@remind/r101-glyphs';
import React from 'react';

import './styles/DropZoneModal.scss';

/**
 * ## Drag-and-drop file upload.
 *
 *
 * ```example
 * <div style={{ width: 450, height: 300, position: 'relative' }}>
 *   <DropZoneModal />
 * </div>
 * ```
 */

type Props = {
  isFileUploaded?: boolean;
  isHovering?: boolean;
  title?: string;
  /** Title when hovering with file over drop zone */
  titleDrop?: string;
  /** Title when hovering with file over drop zone when attachment already exists */
  titleNoDrop?: string;
};

class DropZoneModal extends React.Component<Props> {
  render() {
    const { isFileUploaded, isHovering, title, titleDrop, titleNoDrop, ...props } = this.props;
    let content: {
      containerClass: string;
      glyphName: GlyphName;
      glyphColor: GlyphColor;
      title: string;
    };

    if (isFileUploaded) {
      content = {
        containerClass: 'DropZoneModal-noDrop',
        glyphName: 'disabled',
        glyphColor: 'apple',
        title: titleNoDrop || 'You can upload one file per message.',
      };
    } else {
      content = {
        containerClass: 'DropZoneModal-drop',
        glyphName: 'drag-and-drop',
        glyphColor: 'mascot',
        title: '',
      };
      if (isHovering) {
        content.title = titleDrop || 'Drop attachment!';
      } else {
        content.title = title || 'Drag and drop attachment to upload';
      }
    }

    return (
      <div {...props} className={cx('DropZoneModal', { hover: isHovering && !isFileUploaded })}>
        <div className="DropZoneModal-wrap">
          <Container className={cx('DropZoneModal-container', content.containerClass)}>
            <header className="DropZoneModal-header">
              <Glyph
                color={content.glyphColor}
                name={content.glyphName}
                size="xxlarge"
                className="DropZoneModal-glyph"
              />
              <h2 className="DropZoneModal-title">{content.title}</h2>
            </header>
          </Container>
        </div>
      </div>
    );
  }
}

export default DropZoneModal;
